module.exports = __webpack_public_path__ + "img/google-signin-logo.8019c399.png";